import http, { handleHttpError, handleHttpResponse } from '../../services/http'
import { IEquipment, IProtocol } from '../Equipment/equipment.types.ts'
import { HTTPResponse } from '@/services/http/http.types.ts'
import { IEquipmentGroup } from '../Equipment/equipmentGroup.types.ts'
import { IEnum, IMDMUnit, IMDMUnitInstance, IPassportSchema } from '../MDM/mdm.types.ts'
import { IParameter, IParameterGroup, IUnit, IUnitPrefix } from '../Parameters/parameters.types.ts'
import { IMaintenanceBlankSchema, IMaintenanceProcess } from '../Processes/Maintenance/maintenance.types.ts'
import { IEquipmentModel } from '../Equipment/pages/EquipmentModels/equipmentModels.types.ts'
import { IRole, IUser } from '@/pages/Users/users.types.ts'
import { IAlarmSituation } from '@/pages/Processes/AlarmSituations/alarmSituations.types.ts'
import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import { IDashboard, IDashboardGroup } from '@/pages/Dashboards/dashboards.types.ts'
import { IAccessRight } from '@/services/rights/rights.types.ts'
import { IUserNotification } from '@/services/Notification/notifications.types.ts'

interface IInitDataResponse {
  alarmSituations: IAlarmSituation[]
  dashboards: {
    groups: IDashboardGroup[]
    items: IDashboard[]
  }
  equipment: {
    items: IEquipment[]
    groups: IEquipmentGroup[]
    protocols: IProtocol[]
    models: IEquipmentModel[]
    favourite: IEquipment['id'][]
  }
  mdm: {
    enums: IEnum[]
    units: IMDMUnit[]
    unitInstances: IMDMUnitInstance[]
    passportSchemas: IPassportSchema[]
  }
  units: IUnit[]
  unitPrefixes: IUnitPrefix[]
  parameters: {
    items: IParameter[]
    groups: IParameterGroup[]
  }
  maintenance: {
    blankSchemas: IMaintenanceBlankSchema[]
    processes: IMaintenanceProcess[]
  }
  roles: IRole[]
  user: IUser
  userOrganization: Omit<IOrganization, '_count'>

  organizations: IOrganization[]
  selfAccessRights: IAccessRight[]
  unseenNotifications: IUserNotification[]
}

const initData = (): Promise<HTTPResponse<IInitDataResponse>> => {
  return http.get('/nsi/v1/self/init').then(handleHttpResponse).catch(handleHttpError)
}

const mainApi = { initData }
export default mainApi
